import {useEffect,useState,useContext} from 'react'
import ProjectsEntry from './projectsEntry'
import ProjectsHome from './projectsHome'

export default function Projects(){
    const [projectsKey, setProjectsKey] = useState('');
    const [authKey, setAuthKey] = useState(false)
    const [projectsData, setProjectsData] = useState()
    const [loadingKey, setLoadingKey] = useState(false)

    useEffect(() => {
        sessionStorage.removeItem("token");
    },[])

    async function checkProjectsKey(key){
        setLoadingKey(true)
        try{
            fetch('https://gipapi.azurewebsites.net/planejamento/projetos', {
                method: "GET",
                headers:{
                    'access_token': key,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(json => {
                if(json.MensagemErro != undefined){
                    setLoadingKey(false)
                    alert("Chave inválida. Insira outra e tente novamente!")
                }
                else{
                    console.log(json)
                    setLoadingKey(false)
                    setProjectsKey(key)
                    setProjectsData(json)
                    setAuthKey(true)
                }
            })
        }
        catch(error){
            console.log(error)
        }
    }

    return(
        <>
        {authKey?
            <ProjectsHome data={{projectsData: projectsData,key: projectsKey}}/>
            :
            <ProjectsEntry data={{insertKeyFunction: checkProjectsKey,loadingKeyState: loadingKey}}/>
        }
        </>
    )
}